export default function Product({ src, alt, title, text }) {
    return (<div className="flex flex-col gap-2 group">
        <img className="max-h-[512px] will-change-transform transition-transform group-hover:scale-105" src={src} alt={alt} loading="lazy" height={512} />
        <div className="self-center flex flex-col text-lg 2xl:text-2xl max-lg:items-center max-lg:text-center max-lg:text-white">
            <span className="font-black text-3xl lg:text-lg lg:text-custom-purple text-center w-min">{title}</span>
            <p className="font-bold leading-6 2xl:leading-8">{text}</p>
        </div>
    </div>)
}